import React, { useEffect } from "react";
import Text from "../../../utils/Custom/text";
import CommonForm from "../../../utils/commonComponent/commonForm";
import { useParams } from "react-router-dom";
import { fetchAddresses, fetchQuery } from "../../../utils/commonComponent/fetched";
import AddIcon from "@mui/icons-material/Add";
import {
  booleanOptions,
  inspectionservicesTable,
} from "../../constants/inspectionOption";
import { ClassicTable } from "../clientMaster/ClassicTable";
import {
  Autocomplete,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import { AddButton, CancelButton, SaveAndUpdate } from "../../../utils/Custom/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import axiosWithToken from "../../../utils/commonComponent/axiosTokenConfig";
import { toast } from "react-toastify";
import { BASE_URL, reportLetter, UnicodeCompany } from "../../../global";
import { generatePDFService } from "./inspectionServicePrint";
import axios from "axios";
import { AutoCompletes } from "../../../utils/Custom/custominput";

const EditInspectionService = (props) => {
  const params = useParams();
  const PrintView = props?.print == true;

  const [inputStates, setInputStates] = React.useState({});
  const [clientList, setClientList] = React.useState([]);
  const [inspectionSubCategoryList, setinspectionSubCategoryList] = React.useState([]);
  const [inspectionRows, setInspectionRows] = React.useState([]);
  const [letterHead, setLetterHead] = React.useState(true);

  const inputFields = [
    {
      type: "Autocomplete",
      label: "Client",
      stateKey: "clientId",
      options: "clients",
      valueKey: "id",
      getOptionLabelKey: "companyName",
      disabled: params.id != 0,
    },
    {
      type: "TextField",
      label: "Present Address (for billing):",
      stateKey: "address",
      disabled: true,
    },
    {
      type: "TextField",
      label: "Contact person name",
      stateKey: "contact",
      disabled: true,
    },
    {
      type: "TextField",
      label: "Gst",
      stateKey: "gstNumber",
      disabled: true,
    },
    {
      type: "TextField",
      label: "Service Request No",
      stateKey: "serviceRequestNo",
      disabled: true,
    },
    {
      type: "DatePicker",
      label: "Service Request Date",
      stateKey: "requisitionDate",
      disabled: PrintView,
    },
    {
      type: "TextField",
      label: "Revision Number",
      stateKey: "revisionNumber",
      disabled: PrintView,
    },
    {
      type: "DatePicker",
      label: "Inspection Date",
      stateKey: "inspectionDate",
      disabled: PrintView,
    },
    {
      type: "TextField",
      label: "Inspection Duration",
      stateKey: "duration",
      disabled: PrintView,
    },
    
    // { type: "Heading", label: "Type of Service" },
    {
      type: "Autocomplete",
      options: booleanOptions,
      valueKey: "id",
      getOptionLabelKey: "label",
      label: "Final Random Inspection",
      stateKey: "finalRandomInspection",
      disabled: PrintView,
    },
    {
      type: "Autocomplete",
      options: booleanOptions,
      valueKey: "id",
      getOptionLabelKey: "label",
      label: "First Inspection",
      stateKey: "firstInspection",
      disabled: PrintView,
    },
    {
      type: "Autocomplete",
      options: booleanOptions,
      valueKey: "id",
      getOptionLabelKey: "label",
      label: "Re Inspection",
      stateKey: "reinspection",
      disabled: PrintView,
    },
    {
      type: "Autocomplete",
      options: booleanOptions,
      valueKey: "id",
      getOptionLabelKey: "label",
      label: "During Production Inspection",
      stateKey: "productionInspection",
      disabled: PrintView,
    },
    {
      type: "Textarea",
      label: "If Re-inspection, previous report number",
      stateKey: "previousReportNo",
      disabled: PrintView,
    },
    {
      type: "Autocomplete",
      options: booleanOptions,
      valueKey: "id",
      getOptionLabelKey: "label",
      label: "Sample Random Testing",
      stateKey: "randomTesting",
      disabled: PrintView,
    },
    {
      type: "Autocomplete",
      options: booleanOptions,
      valueKey: "id",
      getOptionLabelKey: "label",
      label: "Supervision of Shipment",
      stateKey: "supervisionShippment",
      disabled: PrintView,
    },
    {
      type: "Autocomplete",
      options: booleanOptions,
      valueKey: "id",
      getOptionLabelKey: "label",
      label: "Welding related services",
      stateKey: "weldingService",
      disabled: PrintView,
    },
    {
      type: "Autocomplete",
      options: booleanOptions,
      valueKey: "id",
      getOptionLabelKey: "label",
      label: "Vendor capability & capability assessment",
      stateKey: "vendorCapability",
      disabled: PrintView,
    },
    {
      type: "Textarea",
      label: "Others",
      stateKey: "others",
      disabled: PrintView,
    },
    {
      type: "TextField",
      label: "Code of const./spec/TDC",
      stateKey: "codeConstnSpec",
      disabled: PrintView,
    },
    {
      type: "TextField",
      label: "Location of Inspection",
      stateKey: "inspectionLocation",
      disabled: PrintView,
    },

    {
      type: "Textarea",
      label: "Terms Conditions",
      stateKey: "termsConditions",
      disabled: PrintView,
    },
  ];

  const updateInputObject = (key, value) => {
    setInputStates((prevInputStates) => ({
      ...prevInputStates,
      [key]: value,
    }));
  };

  const addRangeRow = () => {
    setInspectionRows([...inspectionRows, [{ id: "", subcategory: "", quantity: "" }]]);
  };

  const updateCellValue = (rowIndex, colIndex, value) => {
    const newRows = [...inspectionRows];
    newRows[rowIndex][colIndex] = value;
    setInspectionRows([...newRows]);
  };

  const deleteReadingRow = (rowIndex) => {
    let newReadingRows = [...inspectionRows];
    if (newReadingRows[rowIndex] != undefined) {
      newReadingRows.splice(rowIndex, 1);
      setInspectionRows([...newReadingRows]);
    }
  };

  const fetchClientList = async () => {
    try {
      const query = `select * from clients where status = 1`;
      const clientList = await fetchQuery(query);
      setClientList(clientList);
    } catch (error) {
      console.error("Error fetching clientList:", error);
    }
  };

  const fetchinspectionItems = async () => {
    try {
      const query = `select * from inspectionItems`;
      const inspectionItems = await fetchQuery(query);
      setinspectionSubCategoryList(inspectionItems);
    } catch (error) {
      console.error("Error fetching inspectorList:", error);
    }
  };

  const fetchserviceRequestDetails = async () => {
    try {
      const query = `select * from serviceRequest where status = 1 and id = ${params.id}`;
      const [serviceRequest] = await fetchQuery(query);
      setInputStates(serviceRequest);

      const parsedServices = JSON.parse(serviceRequest.inspectionservices || "[]"); 
      const formattedRows = parsedServices.map((item) => [{ id: item.id, subcategory: item.subcategory, quantity: item.quantity } || ""]);
      setInspectionRows(formattedRows);
    } catch (error) {
      console.error("Error fetching serviceRequest:", error);
    }
  };

  useEffect(() => {
    if (params.id != 0) fetchserviceRequestDetails();
  }, [params]);

  useEffect(() => {
    let currentClient = clientList?.find((i) => i.id == inputStates.clientId);
    const fetchData = async () => {
      if (!currentClient) return;
      const contactsArray = JSON.parse(currentClient.contact || "[]");
      const firstContactPersonName =
        contactsArray.length > 0 ? contactsArray[0].contactPersonName : "";
      // Await the async fetchAddresses call
      let [currentAddress] = await fetchAddresses(currentClient?.address, "0");

      setInputStates((prev) => ({
        ...prev,
        contact: firstContactPersonName,
        gstNumber: currentClient.gstNumber || "",
        address: currentAddress?.address || "",
        companyName: currentClient?.companyName || "",
      }));
    };

    const generateServiceRequestNo = async () => {
      const count = await fetchserviceRequestLast();
      const newCount = count + 1;
      let companyNames = currentClient?.companyName?.trim();
      if (companyNames) {
        const words = companyNames.split(/\s+/); // Split by spaces
        if (words.length > 1) {
          // Step 2: If multiple words, take initials
          companyNames = words.map((word) => word[0].toUpperCase()).join("");
        } else {
          // Step 3: If single word, take first 3 letters
          companyNames = companyNames.substring(0, 3).toUpperCase();
        }
      }
      const companyPrefix = UnicodeCompany || reportLetter;
      const serviceRequestNoCreate = `${companyPrefix}/${companyNames}/25-26/${newCount}`;
      updateInputObject("serviceRequestNo", serviceRequestNoCreate);
    };

    if (currentClient?.companyName && params.id == 0) {
      generateServiceRequestNo();
    }

    fetchData();
  }, [inputStates.clientId]);

  const onSubmit = async () => {
    try {
       const rows = inspectionRows
        .filter((row) => row[0]?.subcategory?.trim())
        .map((row) => ({ id: row[0].id, subcategory: row[0].subcategory.trim(), quantity: row[0].quantity || "",}))


      const mergedRows = [...rows];
      const {
        id,
        gstNumber,
        contact,
        companyName,
        address,
        serviceRequestNo,
        ...restInputStates
      } = inputStates;

      const payload = {
        ...restInputStates,
        inspectionservices:
          mergedRows.length > 0 ? JSON.stringify(mergedRows) : null,
       ...(params.id == 0 && { serviceRequestNo }), // only include for POST
      };

      const url =
        BASE_URL + `serviceRequest${params.id !== "0" ? `/${params.id}` : ""}`;

       params.id == 0
        ? await axiosWithToken.post(url, payload)
        : await axiosWithToken.patch(url, payload);

      toast.success(
        params.id != 0 ? "Service Request updated!" : "Service Request Created!"
      );
      setTimeout(window.location.reload(false), 500);
    } catch (error) {
      console.log(error.message || "Something Went Wrong!");
    }
  };

  useEffect(() => {
    fetchClientList();
    fetchinspectionItems();
  }, []);

  const fetchserviceRequestLast = async () => {
    try {
      const query = `SELECT serviceRequestNo FROM serviceRequest ORDER BY id DESC LIMIT 1;`;
      const result = await fetchQuery(query);
      const lastNumber = result[0]?.serviceRequestNo.split("/").pop() || 0;
      return + lastNumber;
    } catch (error) {
      console.error("Error fetching inspection item count:", error);
      return 0;
    }
  };



  return (
    <div>
      {!PrintView && (
        <Text variant="h3" bold className="text-blue-600">
          {params.id == 0
            ? "Create Insepection Service Request"
            : `Update Insepection Service Request`}
        </Text>
      )}
      {PrintView  && (
        <div className="flex gap-10 mt-5 justify-end ">
          <div className="min-w-[250px]">
            <AutoCompletes
              label="Letter Head"
              options={[
                { id: 1, label: "With Letter Head" },
                { id: 2, label: "Without Letter Head" },
              ]}
              valueKey="id"
              labelKey="label"
              value={letterHead ? 1 : 2}
              onChange={(val) => setLetterHead(val === 1)}
            />
          </div>
          <AddButton
            id="btn-print"
            label="Download PDF"
            onClick={(e) => {
              generatePDFService(inputStates, inspectionRows, letterHead);
            }}
          />
        </div>
      )}
      <br />
      <CommonForm
        inputStates={inputStates}
        updateInputObject={updateInputObject}
        inputFields={inputFields}
      />
      <br />
      {!PrintView && (
        <div className="flex justify-end mb-5">
          <AddButton
            id="btn-add-outline"
            label="Add Service Request"
            icon={<AddIcon fontSize="small" />}
            onClick={(e) => {
              addRangeRow(0);
            }}
          />
        </div>
      )}
      <div style={{ width: "100%", overflow: "auto" }}>
        <ClassicTable>
          <Table sx={{ minWidth: 660 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                {inspectionservicesTable?.map((column) => (
                  <TableCell key={column.field}> {column.headerName}</TableCell>
                ))}
                {!PrintView  && <TableCell>Actions</TableCell>}
              </TableRow>
            </TableHead>
            <TableBody>
              {inspectionRows.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>
                        <Autocomplete
                          size="small"
                          disabled={PrintView}
                          options={inspectionSubCategoryList}
                          getOptionLabel={(option) => option.subcategory || ""}
                          value={inspectionSubCategoryList.find((item) => item.id == row[0]?.id) || null}
                          onChange={(e, newValue) => {
                            updateCellValue(index, 0, {
                              ...row[0],
                              id: newValue?.id || "",
                              subcategory: newValue?.subcategory || "",
                            });
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Select Item"
                              variant="outlined"
                            />
                          )}
                        />
                    </TableCell>
                <TableCell>
                        <TextField
                          id="client_edit_contvalue"
                          size="small"
                          inputProps={{ autoComplete: "off" }}
                          disabled={PrintView}
                          value={row[0]?.quantity || ""}
                          onChange={(e) =>
                            updateCellValue(index, 0, {
                              ...row[0], quantity: e.target.value,
                            })
                          }
                          placeholder="Enter Quantity"
                          type="number"
                        />
                    </TableCell>
                  {!PrintView && (
                    <TableCell>
                      <DeleteIcon
                        id="client_edit_contdelte"
                        style={{ color: "#dc3545", cursor: "pointer" }}
                        onClick={() => deleteReadingRow(index)}
                      />
                    </TableCell>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </ClassicTable>
      </div>

      <br />
      {!PrintView && (
        <div className="flex gap-10 mt-5 justify-end ">
          <CancelButton
            id="btn-cancel"
            label="Cancel"
            outline
            onClick={() => {
              if (window.confirm("Are you sure you want to cancel?")) {
                window.history.back();
              }
            }}
          />
          <SaveAndUpdate
            id="btn-add-outline"
            label={params.id == 0 ? "Save" : "Update"}
            onClick={onSubmit}
          />
        </div>
      )}
    </div>
  );
};

export default EditInspectionService;
